// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorsCard-cls1_cHd","cls2":"AuthorsCard-cls2_HqG AuthorsCard-cls1_cHd"};